export default theme => ({
  autocomplete_container: {
    position: "relative",
  },
  autocomplete_suggestionscontainer__open: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  autocomplete_suggestion: {
    display: "block",
  },
  autocomplete_suggestionslist: {
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
});
